// Copyright © 2026 Gian Marco Cappelli — SAPIENS (finsapiens.it). Tutti i diritti riservati. Sviluppato su commissione esclusiva. Vietata la riproduzione senza autorizzazione scritta.
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';

const cards = [
  {
    id: 'broker',
    href: '/risorse/confronto-broker',
    icon: '📊',
    title: 'Confronto Broker',
    desc: 'Analisi comparativa dei migliori broker italiani ed europei: commissioni, strumenti disponibili, protezione del capitale e affidabilità.',
    badge: 'Aggiornato 2026',
    color: '#5B8DB8',
  },
  {
    id: 'conti-deposito',
    href: '/risorse/confronto-conti-deposito',
    icon: '🏦',
    title: 'Conti Deposito',
    desc: 'Confronto tassi dei migliori conti deposito 2026: liberi e vincolati, garanzia FITD, importi minimi e massimali.',
    badge: 'Tassi live',
    color: '#3D7A52',
  },
  {
    id: 'link-utili',
    href: '/risorse/link-utili',
    icon: '🔗',
    title: 'Link Utili',
    desc: 'Raccolta dei siti istituzionali più importanti: CONSOB, Banca d\'Italia, INPS, Agenzia delle Entrate, MEF e altri.',
    badge: 'Istituzionali',
    color: '#C9A84C',
  },
  {
    id: 'truffe-finanziarie',
    href: '/truffe-finanziarie',
    icon: '🛡️',
    title: 'Truffe Finanziarie',
    desc: 'Impara a riconoscere ed evitare schemi Ponzi, broker truffaldini, criptovalute fake e phishing bancario. Strumenti e checklist di difesa.',
    badge: 'Protezione',
    color: '#E87040',
  },
  {
    id: 'dichiarazione-redditi',
    href: '/guida-dichiarazione-redditi',
    icon: '📋',
    title: 'Dichiarazione dei Redditi',
    desc: 'Guida completa al 730 e Modello Redditi: scadenze, detrazioni e istruzioni passo per passo.',
    badge: 'Fiscale 2026',
    color: '#C9A84C',
  },
];

const RisorseHubPage = () => {
  const navigate = useNavigate();

  return (
    <div className="max-w-4xl mx-auto px-4 py-12 sm:py-20">
      <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} className="mb-10">
        <p className="text-xs text-[#C9A84C] font-semibold tracking-widest uppercase mb-3">Risorse</p>
        <h1 className="text-4xl sm:text-5xl font-bold text-[#E8E8E4] mb-4" style={{ fontFamily: 'Georgia, serif' }}>
          Hub delle Risorse
        </h1>
        <p className="text-lg text-[#888780] max-w-xl leading-relaxed">
          Strumenti curati e aggiornati per prendere decisioni finanziarie informate: confronta broker, tassi e trova i riferimenti istituzionali.
        </p>
      </motion.div>

      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {cards.map((card, i) => (
          <motion.div
            key={card.id}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: i * 0.1 }}
            onClick={() => navigate(card.href)}
            className="rounded-2xl p-6 cursor-pointer transition-all group"
            style={{ background: '#1C1C1A', border: '1px solid rgba(255,255,255,0.08)' }}
            data-testid={`risorse-card-${card.id}`}
          >
            <div className="text-3xl mb-4">{card.icon}</div>
            <div className="flex items-start justify-between mb-2">
              <h2 className="text-lg font-bold text-[#E8E8E4] group-hover:text-[#C9A84C] transition-colors">{card.title}</h2>
              <span className="text-xs px-2 py-0.5 rounded-full ml-2 flex-shrink-0" style={{ background: `${card.color}20`, color: card.color }}>
                {card.badge}
              </span>
            </div>
            <p className="text-sm text-[#888780] leading-relaxed">{card.desc}</p>
            <div className="mt-4 flex items-center gap-1 text-xs font-medium" style={{ color: card.color }}>
              Esplora <span className="group-hover:translate-x-1 transition-transform inline-block">→</span>
            </div>
          </motion.div>
        ))}
      </div>

      {/* Disclaimer */}
      <div className="mt-12 p-4 rounded-xl text-xs text-[#888780]" style={{ background: '#252523', border: '1px solid rgba(255,255,255,0.06)' }}>
        <strong className="text-[#E8E8E4]">Nota editoriale:</strong> Le informazioni presenti nelle sezioni Risorse sono redatte a scopo educativo e informativo. SAPIENS non è un consulente finanziario. Prima di investire, consulta un professionista abilitato.
      </div>
    </div>
  );
};

export default RisorseHubPage;
